export default {
    "获取验证码": "获取验证码",
    "请输入验证码": "请输入验证码",
    "发送":"发送",
    "验证码":"验证码",
    "已发送，请注意查收": "已发送，请注意查收",
    "联系商家": "联系商家",
    "请输入完整的支付密码!" : "请输入完整的支付密码!",
    "加值": "加值",
    "银行卡": "银行卡",
    "平台人工发起退款": "平台人工发起退款",
    "提领": "提领",
    "用户未发表评论": "用户未发表评论",
    '订单': '订单',
    '下单成功，等待付款': '下单成功，等待付款',
    '下单成功，付款成功': '下单成功，付款成功',
    '已发货，正在运输中': '已发货，正在运输中',
    '订单已取消，原因:手动发起取消订单': '订单已取消，原因:手动发起取消订单',
    '订单已取消，原因:超时自动取消订单': '订单已取消，原因:超时自动取消订单',
    "长时间未付款，系统自动取消订单": "长时间未付款，系统自动取消订单",
    '商家已确认，已进入备货状态': '商家已确认，已进入备货状态',
    '系统发货成功': '供应商发货成功',
    '订单已签收': '订单已签收',
    '发起退款申请': '发起退款申请',
    '退款成功': '退款成功',
    '退款失败': '退款失败',
    '订单退款成功': '订单退款成功',
    '订单退款失败': '订单退款失败',
    '系统默认好评': '系统默认好评',
    "请输入关键字搜索": "请输入关键字搜索",
    '充值金额不能小于1': '格式有误:充值金额不能小于1(包含俩位小数)',
    "猜你喜欢": "猜你喜欢",
    "订单已完成": "订单已完成",
    "热销推荐": "热销推荐",
    "头像选择": "头像选择",
    "修改头像": "修改头像",
    "加密货币": "加密货币",
    "银行卡": "银行卡",
    "充值币种": "充值币种",
    '参数缺失': '参数缺失',
    '充值数量必填': '充值数量必填',
    "充值金额": "充值金额",
    "充值金额不得小于": "充值金额不得小于",
    "充值金额不得大于": "充值金额不得大于",
    "请先选择币种": "请先选择币种",
    "开户行": "开户行",
    "请输入开户行名称": "请输入开户行名称",
    "银行卡号": "银行卡号",
    "请输入银行卡号": "请输入银行卡号",
    "点击去支付": "点击去支付",
    "企业证明": "企业证明",
    order: {
        cancel: '取消订单',
        payment: '立即付款',
        remind: '提醒发货',
        return: '申请退货',
        confirm: '确认收货',
        evaluate: '立即评价',
        logistics: '查看物流',
        noRefund: '未退款',
        refunding: '退款中',
        refundSuccess: '退款成功',
        refundFail: '退款失败'
    },
    cancelOrderMap: {
        0: "不想要了",
        1: '下错商品',
        2: '订单重复',
        3: '无法签收',
        4: '其他原因',
    },
    "1": "下错商品",
        "2": "订单重复",
        "3": "无法签收",
        "4": "其他原因",
        "KEY": "中文简体(cn)",
        "-连接已建立-": "-连接已建立-",
        ",才可提币": ",才可提币",
        "[code]值错误": "[code]值错误",
        "[symbol]参数为空": "[symbol]参数为空",
        "goodsFreightTips1": "1、跨境商品运费构成：运费=派送费+长途运费+送货费",
        "creditQuotaINFO": "100,000至30,000,000，额度灵活， 没有限制，最长贷款期限一年。",
        "authentic": "100% 正品",
        "homeIconTips1": "100%正品",
        "goodsFreightTips2": "2、如不满足包邮条件，按实际收取运费产品",
        "goodsFreightTips3": "3、最终解释权归平台所有",
        "dayReturns7": "7 天退货",
        "homeIconTips2": "7天退货",
        "homeIconTips4": "安全付款",
        "safe": "安全无忧",
        "safePayment": "安全支付",
        "homeDownloadtips4": "商城App",
        "homeDownloadtips41": "商家App",
        "keep": "保持",
        "saveQr": "保存二维码",
        "payPal": "贝宝",
        "coinBlock": "币种协议",
        "validatorRequire": "必填项不能为空",
        "edit": "编辑",
        "markDefaultAddress": "标记为默认送货地址",
        "不能为空": "不能为空",
        "cancelOrder2": "不喜欢，不想要",
        "contactUs1": "不想向同学朋友开口借钱，请找我们。",
        "": "",
        "不在交易时段": "不在交易时段",
        "不在可提现时间内": "不在可提现时间内",
        "猜你喜欢": "猜你喜欢",
        "paramError": "参数错误",
        "参数错误": "参数错误",
        "参数异常，消息获取失败": "参数异常，消息获取失败",
        "Operate": "操作",
        "operationSuccess": "操作成功",
        "操作成功": "操作成功",
        "操作类型不能小于0": "操作类型不能小于0",
        "操作类型不是整数": "操作类型不是整数",
        "操作类型为空": "操作类型为空",
        "view": "查看",
        "Checkorder": "查看订单",
        "logistics": "查看物流",
        "CheckDetails": "查看详情",
        "lowOpinion": "差评",
        "产品不存在": "产品不存在",
        "产品剩余数量不足": "产品剩余数量不足",
        "interest": "产生利息",
        "dealSuccess": "成功",
        "successTips": "成功",
        "beSeller": "成为商家",
        "homeBannertips1": "成为商家",
        "承兑商不存在": "承兑商不存在",
        "orderCity": "城市",
        "city": "城市",
        "程序错误": "程序错误",
        "持有币种不足": "持有币种不足",
        "recharge": "充值",
        "rechargeSuccessful": "充值成功",
        "rechargeAddress": "充值地址",
        "rechargeMethod": "充值方式",
        "rechargeRecord": "充值记录",
        "充值价值不得大于最大限额": "充值价值不得大于最大限额",
        "充值价值不得小于最小限额": "充值价值不得小于最小限额",
        "充值金额不能小于1": "充值金额不能小于1(包含俩位小数)",
        "企业电话": "企业电话",
        "职业机会": "职业机会",
        "充值链错误": "充值链错误",
        "rechargeNum": "充值数量",
        "充值数量不能小于等于0": "充值数量不能小于等于0",
        "rechargeTips": "充值提示：“请如实填写实际转账金额，否则可能导致系统审核不通过，影响充值进度。",
        "dealing": "处理中",
        "processing": "处理中",
        "ship": "船",
        "creditText1": "创业贷款 解决借钱的烦恼",
        "businessloan": "创业贷款申请填写",
        "存在不同杠杆的持仓单": "存在不同杠杆的持仓单",
        "cancelOrder7": "存在质量问题",
        "存在重复的角色名称": "存在重复的角色名称",
        "大于最大采购数量": "大于最大采购数量",
        "代理层级错误": "代理层级错误",
        "delivered": "待发货",
        "pendingPayment": "待付款",
        "待付款的订单无法放行": "待付款的订单无法放行",
        "comment": "待评价",
        "receipt": "待收货",
        "pending": "待支付",
        "loanHistory": "贷款记录",
        "rates": "贷款利率",
        "term": "贷款期限",
        "application": "贷款申请",
        "creditWorry": "贷款无忧",
        "orderUnitprice": "单价",
        "当前地址格式错误": "当前地址格式错误",
        "当前订单不为待付款状态，无法取消": "当前订单不为待付款状态，无法取消",
        "当前还需交易": "当前还需交易",
        "currentRate": "当前汇率",
        "sure": "当然",
        "当日才可申购": "当日才可申购",
        "当日可提现次数不足": "当日可提现次数不足",
        "receivedAddress": "到账地址",
        "orderAddress": "地址",
        "登陆密码不符合设定": "登陆密码不符合设定",
        "登陆密码长度不符合设定": "登陆密码长度不符合设定",
        "login": "登录",
        "loginIn": "登录",
        "signIn": "登录",
        "loginSuccess": "登录成功",
        "登录过期，请重新登录": "登录过期，请重新登录",
        "LoginPassword": "登录密码",
        "登录密码必须6-12位": "登录密码必须6-12位",
        "登录密码不能为空": "登录密码不能为空",
        "登录失败": "登录失败",
        "clickUpload": "点击上传",
        "phoneNumber": "电话号码",
        "电话号码已绑定": "电话号码已绑定",
        "电话号码已绑定其他用户": "电话号码已绑定其他用户",
        "email": "电子邮件",
        "shopCollection": "店铺收藏",
        "订单": "订单",
        "trackOrder": "订单",
        "订单不存在": "订单不存在",
        "orderTrack": "订单查询",
        "serialNumber": "订单号",
        "orderSummary": "订单汇总",
        "cancelOrderSuccess": "订单取消成功",
        "订单退款成功": "订单退款成功",
        "订单退款失败": "订单退款失败",
        "orderDetails": "订单详情",
        "orderInfo": "订单信息",
        "订单已签收": "订单已签收",
        "订单已取消": "订单已取消",
        "订单已取消，无法放行": "订单已取消，无法放行",
        "订单已取消，原因:超时自动取消订单": "订单已取消，原因:超时自动取消订单",
        "订单已取消，原因:手动发起取消订单": "订单已取消，原因:手动发起取消订单",
        "订单已完成": "订单已完成",
        "订单已完成，无法放行": "订单已完成，无法放行",
        "moneyOrderStatus": "订单状态",
        "orderPrefix": "订单总额",
        "subscription": "订阅",
        "aboutText2": "额度: 100,000至30,000,000，利息低 还款方式灵活，无任何前期费用，线上放款，不打审核电话，信息保密， 当天放款。",
        "additional": "额外的",
        "evaluateOrderSuccess": "发表评价成功",
        "goodsShip": "发货",
        "发起退款申请": "发起退款申请",
        "send": "发送",
        "发现新版本，请升级到最新版本": "发现新版本，请升级到最新版本",
        "visitStore": "访问商店",
        "collAccount": "放款方式",
        "loanMethod": "放款方式",
        "classification": "分类",
        "服务器错误": "服务器错误",
        "服务器错误(500)": "服务器错误(500)",
        "servicePolicy": "服务政策",
        "PaymentOrder": "付款单",
        "uploadTips": "付款证明（上传付款明细截图）",
        "copy": "复制",
        "copySuccess": "复制成功",
        "该产品未上架": "该产品未上架",
        "该产品已上市，无法购买": "该产品已上市，无法购买",
        "该订单已取消": "该订单已取消",
        "remindRepeat": "该订单已提醒过啦~",
        "该广告剩余数量不足": "该广告剩余数量不足",
        "该基金尚未开放购买": "该基金尚未开放购买",
        "该基金尚已封闭": "该基金尚已封闭",
        "productAvailable": "该商品已下架",
        "该邮箱已被订阅": "该邮箱已被订阅",
        "notOpen": "该支付方式尚未对您所在的地区开放",
        "格式有误:充值金额不能小于1(包含俩位小数)": "格式有误:充值金额不能小于1(包含俩位小数)",
        "userCenter": "个人中心",
        "Item": "个商品",
        "跟单倍数输入错误": "跟单倍数输入错误",
        "跟单参数输入错误": "跟单参数输入错误",
        "more": "更多",
        "更新提醒": "更新提醒",
        "工作地址不能为空": "工作地址不能为空",
        "homeBannertips2": "共同盈利",
        "orderTotal": "共计",
        "buyHistory": "购买记录",
        "购买矿机时间不得低于托管订单剩余时间": "购买矿机时间不得低于托管订单剩余时间",
        "purchageHistory": "购买历史",
        "addCartMessageFaild": "购物车已存在该商品",
        "fixedRate": "固定利率",
        "aboutUs": "关于我们",
        "about": "关于我们",
        "followers": "关注",
        当前余额: "当前余额",
        "备注": "备注",
        "followedSuccess": "关注成功",
        "myFollowedShops": "关注店铺",
        "广告不存在": "广告不存在",
        "广告已下架": "广告已下架",
        "orderSpecification": "规格",
        "countryOf": "国籍",
        "areaCode": "国际区号",
        "orderNation": "国家",
        "nation": "国家",
        "repayment": "还款",
        "repay": "还款方式",
        "reAmount": "还款金额",
        "cycle": "还款周期",
        "loginTips": "还没有账号？",
        "noAccount": "还没有账号？",
        "NoProductSelected": "还未选择商品",
        "shipping": "航运",
        "highOpinion": "好评",
        "favorableRate": "好评率",
        "myPraiseRate": "好评率",
        "totalNum": "合计",
        "partner": "合作供应商",
        "partnersTit": "合作伙伴 - 在线借贷平台",
        "BackHome": "回到首页",
        "or": "或者",
        "freight": "货运",
        "orderFreight": "货运",
        "getCoupons": "获得您更多的优惠券",
        "基金剩余购买金额不足": "基金剩余购买金额不足",
        "quickLoan": "急速放款",
        "records": "记录",
        "proceed": "继续",
        "storeSeachTips3": "家",
        "家庭地址不能为空": "家庭地址不能为空",
        "cancelOrder4": "假冒品牌",
        "price": "价格",
        "piece": "件",
        "transactionPassword": "交易密码",
        "交易员不存在": "交易员不存在",
        "交易员不能跟随自己": "交易员不能跟随自己",
        "交易员跟随人数已满": "交易员跟随人数已满",
        "交易员未开启带单": "交易员未开启带单",
        "交易员无法跟随另一个交易员": "交易员无法跟随另一个交易员",
        "角色被用户关联，不可删除": "角色被用户关联，不可删除",
        "角色不存在": "角色不存在",
        "receiver": "收货人",
        "financial": "解决您的资金困扰",
        "successLoan": "借款成功",
        "borrow": "借款失败",
        "loanAgree": "借款协议",
        "amount": "金额",
        "金额不在购买区间": "金额不在购买区间",
        "validatorMaxNumber": "金额超过限制",
        "金额错误": "金额错误",
        "validatorChineseAndEnglish": "仅支持中英文,输入范围8-64个字符",
        "oldPassword": "旧密码",
        "旧密码不能为空": "旧密码不能为空",
        "旧密码不正确": "旧密码不正确",
        "可平仓合约张数不足": "可平仓合约张数不足",
        "service": "客服",
        "custService": "客户服务",
        "homeDownloadtips1": "跨境电商商城",
        "电商批发商场": "电商商城",
        "矿机不存在": "矿机不存在",
        "矿机未解锁，无法购买": "矿机未解锁，无法购买",
        "From": "来自",
        "历史基金无法购买": "历史基金无法购买",
        "historySearch": "历史搜索",
        "payment": "立即付款",
        "buyNow": "立即购买",
        "homeBannerbtn": "立即加入",
        "evaluate": "立即评价",
        "连续输入错误三次，请3分钟后再试": "连续输入错误三次，请3分钟后再试",
        "contactUs": "联系我们",
        "twoPawword": "两次密码不匹配",
        "creditQuota": "灵活额度",
        "retailPrice": "零售价",
        "领取成功": "领取成功",
        "pageviews": "浏览量",
        "myPageviews": "浏览量",
        "buyRules": "买家规则",
        "买入金额需要在区间内": "买入金额需要在区间内",
        "卖方无法取消该订单": "卖方无法取消该订单",
        "cancelOrder3": "卖家发错货",
        "sellerRules": "卖家政策",
        "noDataFound": "没有找到数据",
        "没有找到用户": "没有找到用户",
        "dailyNewArrival": "每日新品上架",
        "verificationCode":"验证码",
        "pleaseEnterVerificationCode":"请输入验证码",
        "pleaseEnterUsername":"请输入用户名",
        "username": "用户名",
        "password": "密码",
        "getVerificationCode":"获取验证码",
        "tryAgainLater":"秒后再试",
        "密码必须6-12位": "密码必须为6-12位",
        "密码不能为空": "密码不能为空",
        "密码不正确": "密码不正确",
        "wrongPassword": "密码错误次数超过3次, 请明日重试",
        "validatorPassword": "密码为6-12位数字或字母组成(包含特殊字符)",
        "goodsFreeShipping": "免运费",
        "orderName": "名称",
        "defaultAddress": "默认地址",
        "noCartTips": "你的购物袋是空的开始购物",
        "notLogin": "你还没有登录",
        "unSelectedProduct": "你还未选中商品",
        "evaluationUploading": "你还有正在上传的图片,请稍后再试",
        "您当前可分配额度不足": "您当前可分配额度不足",
        "yourEmail": "您的电子邮箱",
        "您没有符合条件的收款方式": "您没有符合条件的收款方式",
        "您已存在订单": "您已存在订单",
        "您已购买过体验矿机,不得重复购买": "您已购买过体验矿机,不得重复购买",
        "photoExample": "拍照示例",
        "homeDownloadtips2": "品牌特卖",
        "Evaluate": "评价",
        "evaluateOrder": "评价晒单",
        "evaluateInput": "评价晒图",
        "homeDownloadtips5": "苹果下载",
        "cancelOrder9": "其他原因",
        "businessPhone": "企业电话",
        "businessEmail": "企业邮箱",
        "walletHistory": "钱包历史",
        "亲属地址不能为空": "亲属地址不能为空",
        "亲属电话不能为空": "亲属电话不能为空",
        "亲属关系不能为空": "亲属关系不能为空",
        "亲属姓名不能为空": "亲属姓名不能为空",
        "empty": "清空",
        "evaluateOrderPlaceholder": "请对评商品做出评价",
        "checkAgreement": "请勾选协议!",
        "请检查网络连接": "请检查网络连接",
        "returnDetailTips": "请评价产品",
        "switchLang": "请切换其他语言后查看",
        "请切换其他语言后查看": "请切换其他语言后查看",
        "请上传图片": "请上传图片",
        "uploadPhoto": "请上传照片",
        "请稍后再试": "请稍后再试",
        "请稍后重试": "请稍后重试",
        "pleaseSetLoginPassword": "请设置登录密码",
        "pleaseSetMobileNumber": "请设置手机号码",
        "pleaseEnterPhoneNumer": "请设置手机号码",
        "plaeseEnterInvitaionCode": "请设置邀请码",
        "pleaseEnterEmail": "请设置邮箱",
        "enterTips": "请输入",
        "pleaseInput": "请输入",
        "validatorFourMoreNumber": "请输入4位以上纯数字",
        "pleaseValidPostCode": "请输入4位以上的数字",
        "validatorSixNumber": "请输入6位纯数字",
        "请输入充值币种": "请输入充值币种",
        "plaseEnterRechargeAddress": "请输入充值地址",
        "pleaseEnterAmount": "请输入充值金额",
        "pleaseInputCorrectNumber": "请输入大于0的数字",
        "pleaseEnterAddress": "请输入地址",
        "请输入关键字搜索": "请输入关键字搜索",
        "headerSearchTips": "请输入关键字搜索",
        "pleaseEnterOldPassword": "请输入旧密码",
        "pleaseEnterPassword": "请输入密码",
        "请输入内容": "请输入内容",
        "plaseeENterConfirmPassword": "请输入确认密码",
        "pleaseEnterQuantity": "请输入数量",
        "请输入搜索关键字": "请输入搜索关键字",
        "withdrawInputTips": "请输入提币地址",
        "plaseeEnterNewPassword": "请输入新密码",
        "yourName": "请输入姓名",
        "pleaseEnterAccount": "请输入账号",
        "请输入正确的货币数量": "请输入正确的货币数量",
        "请输入正确的金额": "请输入正确的金额",
        "validatorPhone": "请输入正确的手机号",
        "pleaseValidPhone": "请输入正确的手机号码",
        "请输入正确的数量": "请输入正确的数量",
        "inpuEmailErro": "请输入正确的邮箱地址",
        "pleaseValidEmail": "请输入正确的邮箱地址",
        "validatorEmail": "请输入正确的邮箱格式",
        "请输入正确的质押金额": "请输入正确的质押金额",
        "请输入正确的质押天数": "请输入正确的质押天数",
        "pleaseCorrectAddress": "请输入正确提币地址",
        "请填写正确的电话号码": "请填写正确的电话号码",
        "请填写正确的验证码": "请填写正确的验证码",
        "mailboxCheck": "请填写正确的邮箱地址",
        "请填写正确的邮箱地址": "请填写正确的邮箱地址",
        "请先绑定谷歌验证器": "请先绑定谷歌验证器",
        "请先添加收款方式": "请先添加收款方式",
        "请先通过高级认证": "请先通过高级认证",
        "cancelOrderTitle": "请选择订单取消原因",
        "selectCountry": "请选择国籍",
        "请选择买卖方式": "请选择买卖方式",
        "selectPeriod": "请选择期限",
        "returnOrderTitle": "请选择退货理由",
        "请选择正确的币种": "请选择正确的币种",
        "请重新登录": "请重新登录",
        "blockchainNetwork": "区块链网络",
        "渠道未开通": "渠道未开通",
        "Cancel": "取消",
        "取消": "取消",
        "cancelSuccess": "取消成功",
        "cancelOrder": "取消订单",
        "cancel": "取消",
        "CancelOrder": "取消订单",
        "myUnfollow": "取消关注",
        "cancelReason": "取消原因",
        "all": "全部",
        "AllProducts": "全部商品",
        "btnSure": "确定",
        "确认": "确认",
        "entRepay": "确认还款",
        "confirmPayPaw": "确认交易密码",
        "confirmPassword": "确认密码",
        "delAllHistoryRecord": "确认删除全部历史记录？",
        "confirm": "确认收货",
        "date": "日期",
        "scanAndDown": "扫码二维码下载APP",
        "homeDownloadtips6": "扫描二维码下载APP",
        "delete": "删除",
        "sellerPanelLogin": "商家登录",
        "merchantSettled": "商家入驻",
        "sellerZone": "成为商家",
        "商家已确认，已进入备货状态": "商家已确认，已进入备货状态",
        "commodity": "商品",
        "orderCommodity": "商品",
        "commodityCollection": "商品集合",
        "productDescription": "商品描述",
        "myCommodityCollection": "商品收藏",
        "goodsNumber": "商品数量",
        "goodsShipTips": "商品下单后，24小时内发货。如下单存在物流管控，订单可能被延时发货，请留意订单物流信息或联系客服",
        "productInfo": "商品信息",
        "uploadSuccess": "上传成功",
        "uploadError": "上传失败，请重试",
        "uploading": "上传中.....",
        "upNew": "上新",
        "previous": "上一步",
        "prevPage": "上一页",
        "cancelOrder5": "少发、漏发",
        "desc": "设为默认地址",
        "setAsTheDefaultAddress": "设为默认地址",
        "setUp": "设置",
        "setSuccess": "设置成功",
        "setUpPayPaw": "设置交易密码",
        "setPassword": "设置密码",
        "申购数量错误": "申购数量错误",
        "申请成功": "申请成功",
        "applyLoan": "申请贷款",
        "applicationAmount": "申请金额",
        "noSmaller": "申请金额不能小于",
        "nomax": "申请金额最大不能超过",
        "applicant": "申请人",
        "applicantDate": "申请日期",
        "return": "申请退货",
        "applicantIn": "申请中",
        "身份证已实名过!": "身份证已实名过!",
        "审核已通过": "审核已通过",
        "审核中": "审核中",
        "state": "省/州/邦",
        "dealFail": "失败",
        "fail": "失败",
        "orderTime": "时间",
        "time": "时间",
        "ActualLedger": "实际到账",
        "actualAccount": "实际账户",
        "实名认证未通过，无法进行高级认证": "实名认证未通过，无法进行高级认证",
        "confirmReceiveGoods": "是否确认收到货",
        "collect": "收藏",
        "collectionSuccess": "收藏成功",
        "wishlist": "收藏商品",
        "cancelOrder6": "收到商品破损",
        "desc5": "收货地址有误？ 联系",
        "consigneeName": "收货人姓名",
        "shippingAddress": "收件地址",
        "pleaseAddShippingAddress": "请先添加收货地址",
        "收款方输入错误": "收款方输入错误",
        "mobile": "手机号",
        '购物车还没有商品': "购物车还没有商品",
        '去购物': "去购物",
        "mobilePhone": "手机号码",
        "handleFee": "手续费",
        "handlingFee": "手续费",
        "home": "首页",
        "授权状态未成功": "授权状态未成功",
        "pleaseSetAreaCode": "输入国家、区号进行搜索",
        "searchCountry": "输入国家、区号进行搜索",
        "desc3": "输入交易密码",
        "desc4": "输入您的交易密码",
        "赎回状态异常": "赎回状态异常",
        "quantity": "数量",
        "orderAmount": "数量",
        "orderQuantity": "数量",
        "inputNum": "数字",
        "orderTax": "税",
        "orderFee": "税费",
        "tax": "税收",
        "delivery": "送货及取货",
        "storeSeach": "搜本店",
        "search": "搜索",
        "所选汇率不存在": "所选汇率不存在",
        "allProduct": "所有产品",
        "提币数量不能小于等于0": "提币数量不能小于等于0",
        "creditText2": "提供创业贷款 资金周转服务",
        "returnOrderSuccess": "提交成功",
        "Submitareview": "提交评论",
        "submitApplica": "提交申请",
        "提交失败": "提交失败",
        "提交失败，当前有未处理订单": "提交失败，当前有未处理订单",
        "hint": "提示",
        "提示": "提示",
        "withdraw": "提现",
        "提现不得大于限额": "提现不得大于限额",
        "提现不得小于限额": "提现不得小于限额",
        "withdrawSuccess": "订单提交成功",
        "withdrawAddress": "提现地址",
        "withdrawRecord": "提现记录",
        "withdrawNum": "提现数量",
        "tipsRemindsSuccess": "提醒成功",
        "remindSuccess": "提醒成功",
        "RemindShip": "提醒发货",
        "remind": "提醒发货",
        "remindTitle": "提醒发货",
        "tipsRemindsText": "提醒发货后，商家会收到提醒",
        "remindContent": "提醒发货后，商家会收到提醒, 只能提醒1次哟~",
        "tipsRemindsMerchant": "提醒商家",
        "days": "天",
        "addCartMessage": "添加到购物车成功",
        "addAddress": "添加地址",
        "addAddressOrModifyAddress": "添加地址/修改地址",
        "addCart": "添加购物车",
        "图片不得大于10M": "图片不得大于10M",
        "图片不得大于2M": "图片不得大于2M",
        "图片大小不能超过2M！": "图片大小不能超过2M！",
        "图片上传失败": "图片上传失败",
        "recommend": "推荐",
        "recommendedProducts": "推荐产品",
        "recommendedStore": "推荐店铺",
        "推荐码不正确": "推荐码不正确",
        "推荐人无权限推荐": "推荐人无权限推荐",
        "推荐商品": "推荐商品",
        "logout": "退出",
        "returnsAndEx": "退货和换货",
        "returnAmount": "退货金额",
        "returnRemark": "退货说明",
        "returnPolicy": "退货政策",
        "Refund": "退款",
        "refund": "退款/售后",
        "退款成功": "退款成功",
        "refundSuccessfully": "退款成功",
        "refundSuccess": "退款成功",
        "returnReason": "退款理由",
        "returnApply": "退款申请",
        "退款失败": "退款失败",
        "refundFail": "退款失败",
        "refundInstructions": "退款说明",
        "refunding": "退款中",
        "mastercard": "万事达卡",
        "EsShop": "网店",
        "ForgotPassword": "忘记密码？",
        "委托数量(张)必填": "委托数量(张)必填",
        "委托数量(张)不能小于等于0": "委托数量(张)不能小于等于0",
        "foryourmoney": "为你解决资金紧张，无处借钱，不好意思向朋友开口借钱等贷款难题，全程专业人员 服务，随时解答你的疑惑不解，我们的目标是让每一笔贷款都透明化，让客户快捷放心的使用。",
        "storeSeachTips1": "为您找到",
        "未绑定谷歌验证器": "未绑定谷歌验证器",
        "未绑定手机号": "未绑定手机号",
        "未绑定邮箱": "未绑定邮箱",
        "未发现授权记录": "未发现授权记录",
        "notQua": "未满足资质条件",
        "ShippingAddressNotSet": "未设置收货地址",
        "未实名认证，是否认证？": "未实名认证，是否认证？",
        "cancelOrder1": "未收到货",
        "未授权访问": "未授权访问",
        "noRefund": "未退款",
        "未找到符合条件的匹配订单": "未找到符合条件的匹配订单",
        "未找到匹配的收益记录": "未找到匹配的收益记录",
        "mine": "我的",
        "myloan": "我的贷款",
        "myOrder": "我的订单",
        "myCart": "我的购物车",
        "我的购物车": "我的购物车",
        "myPurse": "我的钱包",
        "myAccount": "我的帐户",
        "aboutText1": "我们致力于贷款金融服务，基于“客户至上”的经营理念，以解决客户资金周转问题为使命，公司从成立至今，已帮助无数留客户解决资金周转问题。",
        "readAndAgree": "我已阅读并同意",
        "safeInfo": "无抵押贷款，无需押金，不打回访电话， 这本就是一件私密的事。",
        "无权限": "无权限",
        "无效的UID": "无效的UID",
        "item": "物品",
        "系统参数错误": "系统参数错误",
        "系统存在相同[系统登录名]！": "系统存在相同[系统登录名]！",
        "系统错误，请稍后重试": "系统错误，请稍后重试",
        // "系统发货成功": "系统发货成功",
        "系统默认好评": "系统默认好评",
        "defaultRate": "系统默认好评",
        "checkout": "下单",
        "下单不能小于最小金额限制": "下单不能小于最小金额限制",
        "下单成功，等待付款": "下单成功，等待付款",
        "下单成功，付款成功": "下单成功，付款成功",
        "buyTips": "下单后，24小时内发货。以下订单受物流控制，可能会延迟发货。 请关注物流信息或联系客服。",
        "nextPage": "下一页",
        "stateMent": "现代奴隶声明",
        "storeSeachTips2": "相关的店铺",
        "address": "详细地址",
        "items": "项目",
        "browse": "销量",
        "sold": "销售量",
        "sales": "销售量",
        "校验IP不合法": "校验IP不合法",
        "new": "新的",
        "newPassword": "新密码",
        "新密码不能为空": "新密码不能为空",
        "新密码不一致": "新密码不一致",
        "新密码确认不能为空": "新密码确认不能为空",
        "news": "新闻资讯",
        "addNewAddress": "新增地址",
        "creditTit": "信贷服务",
        "Information": "信息",
        "行情获取异常，稍后再试": "行情获取异常，稍后再试",
        "modifyAddress": "修改地址",
        "handlingfee": "需要手续费",
        "Opt": "选择",
        "selectDeliveryAddress": "选择送货地址",
        "验证类型不能为空": "验证类型不能为空",
        "验证码不能为空": "验证码不能为空",
        "验证码不正确": "验证码不正确",
        "验证码错误": "验证码错误",
        "vcodeFail": "验证失败,请重试",
        "vcodePass": "验证通过!",
        "invitationCode": "邀请码",
        "页码不能小于等于0": "页码不能小于等于0",
        "页码不是整数": "页码不是整数",
        "dashboard": "仪表板",
        "loaned": "已贷款",
        "loanDays": "已贷款天数",
        "已发货，正在运输中": "已发货，正在运输中",
        "followed": "已关注",
        "repaid": "已还款",
        "已领取": "已领取",
        "rated": "已评价",
        "cancelled": "已取消",
        "confirmed": "已确认",
        "harvested": "已收货",
        "mySold": "已售",
        "overdue": "已逾期",
        "privacyPolicy": "隐私政策",
        "用户不存在": "用户不存在",
        "用户名必须由数字和英文字母组成": "用户名必须由数字和英文字母组成",
        "用户名不存在": "用户名不存在",
        "用户名不符合设定": "用户名不符合要求",
        "用户名不能为空": "用户名不能为空",
        "用户名参数为空": "用户名参数为空",
        "用户名重复": "用户名重复",
        "userEvaluation": "用户评价",
        "用户剩余数量不足": "用户剩余数量不足",
        "用户未发表评论": "用户未发表评论",
        "用户已跟随交易员": "用户已跟随交易员",
        "user_Center": "用户中心",
        "userReg": "用户注册",
        "postCode": "邮编",
        "orderEmail": "邮箱",
        "邮箱已绑定": "邮箱已绑定",
        "邮箱已绑定其他用户": "邮箱已绑定其他用户",
        "orderPostCode": "邮政编码",
        "hasImage": "有图",
        "Balance": "余额",
        "balance": "余额（USDT）",
        "余额不足": "余额不足",
        "balanceNot": "余额不足，请充值",
        "cancelOrder8": "与商家协商一致退款",
        "expectedArrival": "预计到货",
        "esRepayment": "预计还款",
        "estirepay": "预计还款",
        "originPrice": "原价",
        "deliveryFee": "运费",
        "goodsFreight": "运费",
        "shippingDiscounts": "运费折扣",
        "homeIconTips3": "运费折扣",
        "desc6": "再次输入您的交易密码",
        "rebuy": "再来一单",
        "onlineService": "在线服务",
        "customeService": "在线客服",
        "helpLine": "在线客服",
        "onlineApplin": "在线申请",
        "暂无店铺": "暂无店铺",
        "noComments": "暂无评价",
        "noData": "暂无数据",
        "帐户异常需要进行C3认证，请联系在线客服。": "帐户异常需要进行C3认证，请联系在线客服。",
        "account": "账户",
        "accountBalance": "账户余额",
        "accountB": "账户余额",
        "accountReview": "账户总览",
        "Recruitment": "招贤纳士",
        "找不到用户": "找不到用户",
        "searchTips": "找货源/商品/供应商/求购",
        "discount": "折扣",
        "homeDownloadtips3": "折扣不停",
        "discounted": "折扣商品",
        "actualName": "真实姓名",
        "passPortImg": "证件号码/护照号码",
        "uploadId": "证件照/护照上传",
        "Payment": "支付",
        "pay": "支付",
        "paymentSuccessful": "支付成功",
        "paymentPending": "支付待确认",
        "paymentPendingDesc": "您的支付正在处理中，请稍后查看订单状态",
        "paymentMethod": "支付方式",
        "paymethods": "支付方式",
        "payCertificate": "支付凭证",
        "直线关系，不能修改推荐": "直线关系，不能修改推荐",
        "tipsRemindsCount": "只能提醒1次哟~",
        "committed": "致力于创业者贷款服务",
        "mediumOpinion": "中评",
        "sort": "种类",
        "重复提交": "重复提交",
        "Reapply": "重新申请",
        "register": "注册",
        "signUp": "注册",
        "registerSuccess": "注册成功",
        "转账币种不能为空": "转账币种不能为空",
        "转账数量不能小于等于0": "转账数量不能小于等于0",
        "orderStatus": "状态",
        "orderState": "状态",
        "状态不能小于0": "状态不能小于0",
        "状态不是整数": "状态不是整数",
        "资金密码必须6-12位": "资金密码必须为6-12位",
        "资金密码不符合设定": "资金密码不符合要求",
        "资金密码不能为空": "资金密码不能为空",
        "资金密码错误": "资金密码错误",
        "资金密码长度不符合设定": "资金密码长度不符合要求",
        "complex": "综合",
        "totalOf": "总计",
        "totalPrice": "总价",
        "homeBannertips3": "最高",
        "creditReview": "最快一小时通过审核，审核通过立即下款。",
        "yesterday": "昨天",
        "binance": "Binance",
        "huobi": "Huobi",
        "validatorIpRule": "IP格式不正确",
        "metaMask": "MetaMask",
        "footTip": "{name} 2024 版权所有",
        "footTips": "{name} Limited 作为信贷经纪人 (713206)获得金融行为监管局的授权和监管，并专门与贷方 Home Retail Group CardServices Limited 合作，以 {name} Financial Services的身份进行交易，{name} Financial Services获得金融行为监管局的授权和监管以提供信贷(716148)。Home Retail GroupCard Services Limited 注册于英国 (04007072)，地址为 Avebury, 489-499Avebury Boulevard, Milton Keynes, United Kingdom。MK9 2NW。",
        "footdec": "{name}全球站的用户来自全球{num}个国家，可以在全球范围内实现即时低成本交易，无需等待，没有国际费用。",
        "okx": "okx",
        "UID不能为空": "UID不能为空",
        "recommendclass": "推荐分类",
        "滑动验证": "滑动验证",
        "subOrder":"提交订单",
        "最多上传9张图片": "最多上传9张图片",
        "账号注销": "账号注销",
        "确定注销": "确定注销",
        "您的账号": "您的账号",
        "为什么要离开": "为什么要离开",
        "您还有余额,不能注销账号": "您还有余额,不能注销账号!",
        "请输入注销理由": "请输入注销理由!",
        "您确认要注销吗?": "您确认要注销吗?",
        "我再考虑下": "我再考虑下",
        "同意注销": "同意注销",
        "注销成功": "注销成功",
        "cancelInfo":"警告！请谨慎操作注销账户，如果您不再使用该账号，可点击【同意注销】，注销后可能几天内无法注册。",
        "App下载(买家端)": "App下载(买家端)",
        "App下载(卖家端)": "App下载(卖家端)",
        "请选择":"请选择",
        "提款地址绑定": "提款地址绑定",
        "绑定成功": "绑定成功",
        "仅能绑定一个收款地址!": "仅能绑定一个收款地址!",
        "最多包含10位小数": "最多包含10位小数",
        "footTipTikTok":"CoveBuy Mall ©️2024 版权所有",
        "客户端下载":"客户端下载",
        "提现方式": "提现方式",
        "TikTokFoot":"CoveBuy Mall是全球短视频社交平台CoveBuy与亚洲最大的批发贸易公司Alibaba合作成立的，面向全球的电子商务平台，并在全球拥有三大自营智能仓库分别位于加拿大多伦多、美国洛杉矶及日本千叶。App内在售商品包含来自日本、韩国、中国等亚洲人气商品，目前总数已超过50,000款，并在持续快速增长中。",

    // ==================== 游客结账 ====================
    "contactInfo": "联系信息",
    "shippingAddress": "收货地址",
    "consignee": "收货人姓名",
    "enterName": "请输入姓名",
    "phone": "手机号",
    "enterPhone": "请输入手机号",
    "country": "国家",
    "enterCountry": "请输入国家",
    "province": "省份/州",
    "enterProvince": "请输入省份/州",
    "enterCity": "请输入城市",
    "detailAddress": "详细地址",
    "enterAddress": "街道地址、门牌号等",
    "continueToCheckout": "继续结账",
    "emailRequired": "请输入邮箱",
    "emailInvalid": "邮箱格式不正确",
    "nameRequired": "请输入姓名",
    "phoneRequired": "请输入手机号",
    "countryRequired": "请输入国家",
    "addressRequired": "请输入地址",
    "emailRegistered": "该邮箱已注册，您可以在结账后登录。",
    "registerFailed": "注册失败",
    "accountExists": "账户已存在，请登录后继续",
    "registerSuccess": "账户创建成功",
    "operationFailed": "操作失败",

    // ==================== 重置密码 ====================
    "resetPassword": "重置密码",
    "emailVerification": "邮箱验证",
    "setNewPassword": "设置新密码",
    "complete": "完成",
    "enterEmail": "请输入注册邮箱",
    "sendVerifyCode": "发送验证码",
    "codeSent": "验证码已发送",
    "sendFailed": "验证码发送失败",
    "enterVerifyCode": "请输入验证码",
    "codeRequired": "请输入验证码",
    "newPasswordPlaceholder": "请输入新密码（6-20个字符）",
    "newPasswordRequired": "请输入新密码",
    "newPasswordLength": "密码长度为6-20个字符",
    "confirmNewPassword": "确认新密码",
    "confirmPasswordRequired": "请确认密码",
    "passwordMismatch": "两次密码不一致",
    "resetSuccess": "密码重置成功",
    "resetFailed": "密码重置失败",
    "goToLogin": "去登录",
    "resetPasswordSuccess": "您的密码已成功重置，现在可以使用新密码登录。",
    "betaBannerText": "网站公测中，请勿下单"
};
